import React from 'react';

const Blog = () => {
   return (
      <div className='flex items-center justify-center min-h-screen'>
         <h2 className='text-primary text-4xl md:text-6xl animate-bounce'>Coming soon...................</h2>
      </div>
   );
};

export default Blog;